import { Modal } from '../modal/modal';
import { ReactComponent as ClockIcon } from "../../assets/icons/outline/icon_clock.svg";
import { Utils } from '../../utilities/utils';
import { GroupIds } from '../../models/enumerations/group-ids';
import PortalProgressBar from '../portal-progress-bar/portal-progress-bar';
import { useTranslation } from 'react-i18next';
import { CorrectiveProgramRoutine } from '../../models/interfaces/corrective-exercises/corrective-program-routine';
import i18n from '../../i18n';
import JWVideoPlayer from '../jw-video-player/jw-video-player';

const COMPONENT_CLASS = "c-exercise-modal";

interface ExerciseModalProps {
    programRoutine: CorrectiveProgramRoutine;
    openExerciseModal: boolean;
    setOpenExerciseModal: React.Dispatch<React.SetStateAction<boolean>>;
    programProgressCurrent?: number;
    programProgressTotal?: number;
}

const ExerciseModal: React.FC<ExerciseModalProps> = (props) => {
    const {
        programRoutine,
        openExerciseModal,
        setOpenExerciseModal,
        programProgressCurrent,
        programProgressTotal,
    } = props;

    const { t } = useTranslation();
    const duration = programRoutine.duration ?? 0
    return (
        <Modal
            isOpen={openExerciseModal}
            isLoading={false}
            onClose={setOpenExerciseModal}
        >
            <div className={COMPONENT_CLASS}>
                <div className='flex flex-col grow gap-4 justify-center'>
                    <div className='flex justify-between items-center gap-4'>
                        <div>
                            <h1 style={{ margin: "0" }}>
                                {programRoutine.translations?.[i18n.language]?.title}
                            </h1>
                        </div>

                        <div className={`${COMPONENT_CLASS}__focus-icon`}>
                            {Utils.getFocusAreaData(GroupIds.MOVEMENT_HEALTH).icon}
                        </div>
                    </div>

                    <div className='flex justify-between items-center gap-4'>
                        {programProgressCurrent !== undefined &&
                            programProgressCurrent !== null &&
                            programProgressTotal !== undefined &&
                            programProgressTotal !== null &&
                            <div className='w-2/3'>
                                <div className='flex justify-between items-center gap-4'>
                                    <div className='text-10 font-bold uppercase'>
                                        {t('userProfile.programProgress')}
                                    </div>
                                    <div className='text-sm font-medium'>
                                        {programProgressCurrent}/{programProgressTotal}
                                    </div>
                                </div>
                                <div className='w-full'>
                                    <PortalProgressBar total={programProgressTotal} currentProgress={programProgressCurrent} headerText="" fillColor="#43B5F8" />
                                </div>
                            </div>
                        }

                        <div className='flex items-center gap-1 text-xs font-light'>
                            <div><ClockIcon /></div>
                            {duration === 1 ? t('userProfile.exerciseDuration.minutes.singular', { value: duration }) : t('userProfile.exerciseDuration.minutes.plural', { value: duration })}
                        </div>
                    </div>
                </div>

                <hr />
                {programRoutine.translations?.[i18n.language].summary &&

                    <div className='text-12 font-light pb-6 self-stretch flex items-center' style={{ borderRadius: "10px", lineHeight: "18px" }}>
                        <p>{t(programRoutine.translations?.[i18n.language].summary)}</p>
                    </div>
                }
                <div
                    className="overflow-auto text-xs font-light flex flex-wrap gap-6"
                    style={{ maxHeight: "50vh" }}>
                    {programRoutine.exercises?.map((exercise, index) => (
                        <div
                            key={exercise.videoId ?? index}
                            className="bg-black-gray-5 p-4 flex gap-4 items-start"
                            style={{
                                width: "calc(50% - 12px)",
                                borderRadius: "10px",
                            }}
                        >
                            <div
                                className="w-3/5 shrink-0 overflow-hidden"
                                style={{ borderRadius: "10px" }}
                            >
                                <JWVideoPlayer
                                    video={{ videoId: exercise.videoId, videoUrl: undefined }}
                                    aspectRatio="16:9"
                                    autoStartViewable={false}
                                    showThumbnail={true}
                                    thumbnailUrl={exercise.imageUrl}
                                />
                            </div>
                            <div style={{ margin: "auto", display: "flex", flexDirection: "column", gap: "8px" }}>
                                <span className='text-xs font-medium'>{t(exercise.translations?.[i18n.language]?.title)}</span>
                                <span className="inline-flex items-center gap-1">
                                    <ClockIcon />
                                    {t('general.time.sec', { count: exercise.duration })}
                                    {exercise.isBilateral && ` ${t('userProfile.wellnessProgram.eachSide')}`}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default ExerciseModal;